import React, { FC } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import BackButton from './BackButton';

interface PageHeaderProps {
  mainTitle?: string;
  subTitle?: string;
  backButtonLabel?: string;
  backButtonLink?: string;
  button?: React.ReactNode;
  titleIcon?: React.ReactNode;
}

const PageHeader: FC<PageHeaderProps> = (props) => {
  const { mainTitle, subTitle, backButtonLabel, backButtonLink, button, titleIcon } = props;

  return (
    <Grid container style={{ marginTop: 20, marginBottom: 8 }}>
      {backButtonLink && (
        <Grid item xs={12} style={{ marginBottom: 8 }}>
          <BackButton buttonLabel={backButtonLabel} buttonLink={backButtonLink} />
        </Grid>
      )}
      <Grid item xs={12} style={{ marginBottom: 8 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Grid container alignItems="center" spacing={2}>
              {titleIcon && (
                <Grid item>
                  <Box sx={{ display: 'flex', '& svg': { fontSize: 40, color: 'primary.main' } }}>
                    {titleIcon}
                  </Box>
                </Grid>
              )}
              <Grid item>
                <Typography variant="h4" fontWeight="bold" sx={{ mb: subTitle ? 0.5 : 0 }}>
                  {mainTitle}
                </Typography>
                {subTitle && (
                  <Typography variant="body1" color="text.secondary">
                    {subTitle}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
          {button && <Grid item>{button}</Grid>}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default PageHeader;
